import React, {useEffect, useState} from 'react';
import './Profile.css';
import ProfileHeader from "./ProfileHeader/ProfileHeader";
import GameCard from "./GameCard/GameCard";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import loadingGif from "../ChooseCorts/loading.gif";
import ConnectionError from "../ConnectionError/ConnectionError";

const Profile = () => {

    const navigate = useNavigate();
    // const [userGames, setUserGames] = useState([{date: 12, day_of_week: 'asd', time: 123, today: true}, {date: 12, day_of_week: 'asd', time: 123, today: true}, {date: 12, day_of_week: 'asd', time: 123, today: true}, {date: 12, day_of_week: 'asd', time: 123, today: true}, {date: 12, day_of_week: 'asd', time: 123, today: true}]);
    const [userGames, setUserGames] = useState([]);
    const [auth, setAuth] = useState(null);

    useEffect(() => {
        axios.get(`/api/my-orders/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                setAuth(true);
                setUserGames(res.data.detail);
                console.log(res.data.detail);
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
                else {
                    setAuth(false);
                    // setAuth(true); // delete after
                }
            })
    }, [setUserGames, setAuth]);

    if (auth === null) {
        return (<div className={'loading-block-auth'}><img src={loadingGif} alt={'Loading...'}
                                                           className={'loading-gif-auth'}/></div>);
    }

    // if (auth === false) {
    //     return (<div className={'access-error'}>Неполадки с доступом, попробуйте зайти позже.</div>);
    // }

    if (auth === false) {
        return (<ConnectionError />);
    }

    const goToReserve = () => {
        navigate('/reserve');
    }

    return (
        <div className={'profile-container'}>
            <ProfileHeader />
            <div className={'profile-body-container'}>
                <p className={'profile-body-label'}>Мои игры:</p>
                <div className={'profile-body-games'}>
                    {/*<GameCard date={'19 ноября 2025'} weekday={'Суббота'} time={'18:00'} active={true} />*/}
                    {/*<GameCard date={'19 ноября 2025'} weekday={'Суббота'} time={'18:00'} active={false} />*/}
                    {/*<GameCard date={'19 ноября 2025'} weekday={'Суббота'} time={'18:00'} active={false} />*/}
                    {/*<GameCard date={'19 ноября 2025'} weekday={'Суббота'} time={'18:00'} active={false} />*/}
                    {/*<GameCard date={'19 ноября 2025'} weekday={'Суббота'} time={'18:00'} active={false} />*/}
                    {userGames.length!==0 && userGames.map((game, index) => (
                        <GameCard
                            key={index}
                            date={game.date}
                            weekday={game.day_of_week}
                            time={game.time}
                            active={game.today}
                            cort={game.name}
                            gameId={game.id}
                        />
                    ))}
                </div>
            </div>
            <div className={'profile-footer'}>
                <button className={`profile-footer-btn ${userGames.length===5 ? 'profile-footer-btn-disabled' : ''}`} onClick={() => goToReserve()}>Добавить игру!</button>
                <p className={'profile-footer-text'}>{userGames.length===5 ?
                    'Вы не можете пока бронировать игры'
                    :
                    // <p className={'profile-footer-text-title'}>
                    //     {'Вы можете забронировать'}
                        <pre className={'profile-footer-text-description'}>
                            {
`• не более 1 игры в сутки
• не более 2 игр в неделю 
• не более 5 игр в целом`
                            }
                        </pre>
                    // </p>
                }</p>
            </div>
            <div className={'profile-bg'}></div>
        </div>
    );
};

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default Profile;